import script from "./ConfigurationPackageInformationOptional.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigurationPackageInformationOptional.vue?vue&type=script&setup=true&lang=js"

import "./ConfigurationPackageInformationOptional.vue?vue&type=style&index=0&id=4fe3b4df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fe3b4df"]])

export default __exports__